import { Currency } from "../../../types/Currency/Currency";
import { LicenceTypePurchase } from "../../../types/Licences/LicenceTypePurchase";
import { PricingRule } from "../../../types/PricingRule/PricingRule";
import ConcurrentPricing from "./ConcurrentPricing";
import SingleUserPricing from "./SingleUserPricing";

interface LicencePricingProps {
  licence: LicenceTypePurchase;
}

const LicencePricing = ({ licence }: LicencePricingProps) => {
  return (
    <>
      {licence.licenceType === "SingleUser" ? (
        <SingleUserPricing licence={licence} />
      ) : licence.licenceType === "Concurrent" ? (
        <ConcurrentPricing licence={licence} />
      ) : null}
    </>
  );
};

export default LicencePricing;
